import React from 'react';
import Select from 'react-select-plus';
import { useIntl, FormattedMessage } from '@kyruus/intl';
import _omit from 'lodash/omit';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _reduce from 'lodash/reduce';

export const IntlOption = ({
  messageDescriptor,
  messageDescriptorValues,
  ...props
}) => {
  const intl = useIntl();
  const label = intl.formatMessage(messageDescriptor, messageDescriptorValues);
  return (
    <option {...props} label={label}>
      {label}
    </option>
  );
};

export const IntlReactSelect = ({
  optionsMessageDescriptors,
  ariaMessageDescriptor,
  placeholderMessageDescriptor,
  placeholderMessageDescriptorValues,
  defaultPlaceholderMessageDescriptor,
  ...props
}) => {
  const intl = useIntl();
  const options = _map(optionsMessageDescriptors, (descriptor) => {
    if (descriptor.labelMessageDescriptor) {
      descriptor.label = intl.formatMessage(
        descriptor.labelMessageDescriptor,
        descriptor.labelMessageDescriptorValues
      );
    }
    if (descriptor.options) {
      descriptor.options = _map(descriptor.options, (option) => {
        option.label = intl.formatMessage(option.labelMessageDescriptor);
        return _omit(option, 'labelMessageDescriptor');
      });
    }
    return _omit(descriptor, [
      'labelMessageDescriptor',
      'labelMessageDescriptorValues'
    ]);
  });
  if (options.length) {
    props.options = options;
  }
  if (placeholderMessageDescriptor) {
    if (intl.messages[placeholderMessageDescriptor.id]) {
      props.placeholder = intl.formatMessage(
        placeholderMessageDescriptor,
        placeholderMessageDescriptorValues
      );
    } else {
      props.placeholder = intl.formatMessage(
        defaultPlaceholderMessageDescriptor
      );
    }
  }
  props['aria-label'] = intl.formatMessage(ariaMessageDescriptor);

  // set data-testid
  props.inputProps = { ...props.inputProps, 'data-testid': props.instanceId };

  return <Select {...props} />;
};

export const FormattedEmptyDefaultMessage = (props) => {
  const intl = useIntl();
  return _get(intl.messages, props.id) ? <FormattedMessage {...props} /> : null;
};

function makeInternational(Component) {
  const InternationalComponent = ({ intlProps, componentRef, ...props }) => {
    const intl = useIntl();
    const translatedProps = _reduce(
      intlProps,
      (acc, description, prop) => {
        acc[prop] = intl.formatMessage(
          description.descriptor,
          description.values
        );
        return acc;
      },
      {}
    );
    return <Component {...translatedProps} ref={componentRef} {...props} />;
  };
  const componentName =
    typeof Component === 'string' ? Component : Component.displayName;
  InternationalComponent.displayName = `InternationalComponent(${componentName})`;
  return InternationalComponent;
}

export { makeInternational };
